export default __webpack_public_path__ + "static/media/SchoggiTransparent.6e6f85d7.png";